export default "__VITE_ASSET__9774fa2c__"